<script>
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import Checkbox from "../../components/Checkbox.svelte";

	export let title = null;
	export let pageTitle = null;
	export let lastVisitedPage = null;
	export let disabled = null;

	let buttons;

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		//  Get the user Agent
		$model.UserAgent = navigator.userAgent;
		$model.referrer = document.referrer;
		$model.RegistrationSegmentId = null;
	}

	const handleSubmit = (e) => {
		buttons.blockNext();

		e.preventDefault();

		grecaptcha.ready(function () {
			grecaptcha.execute(projectSettings.gSiteKey, { action: "submit" }).then(async function (token) {
				let options = {
					method: "POST",
					headers: {
						"Content-type": "application/json"
					},
					body: JSON.stringify({ token: token })
				};

				var url = "/api/verify";
				let response = await fetch(`${url}`, options);
				if (response.ok) {
					let data = await response.json();

					if (data && data.status === true) {
						registerFormStart();

						buttons.next();
						buttons.unblock();
						return true;
					}
				}

				buttons.unblock();
				return false;
			});
		});
	};
</script>

<PageSection>
	<Form id="form-landing-page" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h1 class="text-center">Register for the {@html projectSettings.classActionName}</h1>
			</FormColumn>
		</FormRow>

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>To be a part of the KFC Breaks Class Action, you must be:</p>
				<ul class="bullet-point-left-indent">
					<li>a current or former KFC worker; and</li>
					<li>worked at a KFC restaurant in Australia between 4 December 2017 and 4 December 2023; and</li>
					<li>not received at least one 10 minute paid break you were entitled to.</li>
				</ul>

				<p>
					To register on a confidential, no-cost, no-obligation basis, please complete the following
					registration form.
				</p>
			</FormColumn>
		</FormRow>

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<!-- svelte-ignore a11y-label-has-associated-control -->
					<label class="mb-3">
						Do you agree to provide us with personal information which will be kept confidential under the
						Shine Lawyers
						<a href="https://www.shine.com.au/privacy-policy" title="Privacy Policy" target="_blank"
							>Privacy Policy</a
						>?
					</label>
					<Checkbox
						required="true"
						{disabled}
						bind:checked={$model.privacyPolicyConfirmed}
						label="I agree to the privacy policy"
						id="privacy"
					></Checkbox>
				</FormColumn>
			</FormRow>
		</div>

		<FormRow class="justify-content-md-center register-btn confirmation-hide">
			<FormColumn class="text-center">
				<NavigationButtons
					showPrevious={false}
					bind:buttons
					nextPageLabel="REGISTER FOR THE CLASS ACTION"
					disableNext={!$model.privacyPolicyConfirmed}
				>
					tealiumTag={false}
					pageName={title}
				</NavigationButtons>
			</FormColumn>
		</FormRow>

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					If you require support completing your registration, please contact Shine Lawyers on
					<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
					<ClassActionEmailAddress></ClassActionEmailAddress>.
				</p>
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	.bullet-point-left-indent {
		padding-left: 40px;
	}
</style>
